import { CurrencyPipe } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChange,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectedPuppetTab } from '@models/puppet.class';
import { Store } from '@ngrx/store';

import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { size } from 'lodash';
import { EMPTY, of, Subscription, timer } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  mergeMap,
  take,
} from 'rxjs/operators';
import { TRACKING_EVENTS, USER_ROLES } from 'src/app/app.constants';
import { config } from 'src/app/environment-config';
import { SelectTab } from 'src/app/state/actions/operation-puppet.actions';
import { AppState } from 'src/app/state/app-state';
import {
  BLOTTER_CANCELREPLACE,
  CURRENT_SYMBOL,
  OPERATION_HARD_RESET,
  OPERATION_RESET,
} from 'src/app/state/app.reducer';
import { selectIsUsa } from 'src/app/state/selectors/current-contract.selectors';
import { FieldSort } from 'src/components/shared/utility/field-sort';
import {
  TRADING_ORDER_STATUS,
  TRADING_USA_ORDER_STATUS,
  TRADING_ORDER_STATUS_CUSTOM,
  TRADING_ORDER_WAYS,
} from '@models/trades.class';
import { AnalyticsTrackingService } from 'src/core/services/analyticsTracking.service';
import { BootstrapService } from 'src/core/services/bootstrap.service';
import { NotificationService } from 'src/core/services/notification.service';
import { PatronService } from 'src/core/services/patron.service';
import { SearchService } from 'src/core/services/search.service';
import { TradeService } from 'src/core/services/trade.service';
import { UtilitiesService } from 'src/core/services/utilities.service';
import { OrderByPipe } from 'src/shared/pipes';
import { MarketType, SharedSolaceStreamService } from 'src/solace';
import {
  DisplayedCapitalBlotterColumn,
  TRADING_MX_COLUMNS,
  TRADING_USA_COLUMNS,
} from './blotter-capitals.configuration';
import { CancelAndReplaceConfirmationComponent } from './cancelAndReplaceConfirmation.component';

const env = config();
const { timeOuts_timeOut30Seg } = env;

@Component({
  selector: 'hb-blotter-capitals',
  templateUrl: './blotterCapitals.component.html',
  providers: [CurrencyPipe],
})
export class BlotterCapitalsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isInPortfolio: boolean;
  @Input() showDownloadExcel: boolean;
  @Input() isRefreshing: boolean;

  public constTop = 0;
  public constLeft = 0;

  public bootstrapPromise: Promise<any>;
  public orders: BlotterOrderItem[] = [];
  public sorting: any = {
    prop: 'hour',
    reverse: true,
  };

  public tradingOrderStatus = TRADING_ORDER_STATUS;
  public tradingOrderStatusCustom = TRADING_ORDER_STATUS_CUSTOM;
  public tradingOrderWays = TRADING_ORDER_WAYS;

  public statusOrders: any = {
    [TRADING_ORDER_STATUS.pendingNew]: 'Pendiente',
    [TRADING_ORDER_STATUS.new]: 'En proceso',
    [TRADING_ORDER_STATUS.cancelPending]: 'En revisión',
    [TRADING_ORDER_STATUS.cancelRejected]: 'Cancelación rechazada',
    [TRADING_ORDER_STATUS.filled]: 'Completada',
    [TRADING_ORDER_STATUS.partiallyFilled]: 'Parcial',
    [TRADING_ORDER_STATUS.cancelled]: 'Cancelada',
    [TRADING_ORDER_STATUS.rejected]: 'Rechazada',
    [TRADING_ORDER_STATUS.ackGbm]: 'Pre-aprobada',
    [TRADING_USA_ORDER_STATUS.pending]: 'Pendiente',
    [TRADING_USA_ORDER_STATUS.executing]: 'En proceso',
    [TRADING_USA_ORDER_STATUS.sent]: 'Enviada',
    [TRADING_USA_ORDER_STATUS.canceled]: 'Cancelada',
    [TRADING_USA_ORDER_STATUS.finishedTrading]: 'Completada',
    [TRADING_USA_ORDER_STATUS.executed]: 'Completada',
    [TRADING_USA_ORDER_STATUS.executedWithErrors]: 'No realizada',
    [TRADING_USA_ORDER_STATUS.expired]: 'No realizada',
    [TRADING_USA_ORDER_STATUS.rejected]: 'Rechazada',
    [TRADING_ORDER_STATUS_CUSTOM.cancelRejectedAndFilled]: 'Completada',
  };
  public iconStatus: any = {
    [TRADING_ORDER_STATUS.pendingNew]: 'pending',
    [TRADING_ORDER_STATUS.new]: 'new',
    [TRADING_ORDER_STATUS.cancelPending]: 'cancel-pending',
    [TRADING_ORDER_STATUS.cancelRejected]: 'cancel-rejected',
    [TRADING_ORDER_STATUS.filled]: 'filled',
    [TRADING_ORDER_STATUS.partiallyFilled]: 'partial',
    [TRADING_ORDER_STATUS.cancelled]: 'cancelled',
    [TRADING_ORDER_STATUS.rejected]: 'rejected',
    [TRADING_ORDER_STATUS.ackGbm]: 'pre-approved',
    [TRADING_USA_ORDER_STATUS.pending]: 'pending',
    [TRADING_USA_ORDER_STATUS.executing]: 'executing',
    [TRADING_USA_ORDER_STATUS.sent]: 'sent',
    [TRADING_USA_ORDER_STATUS.canceled]: 'cancelled',
    [TRADING_USA_ORDER_STATUS.finishedTrading]: 'finished',
    [TRADING_USA_ORDER_STATUS.executed]: 'executed',
    [TRADING_USA_ORDER_STATUS.executedWithErrors]: 'error',
    [TRADING_USA_ORDER_STATUS.expired]: 'error',
    [TRADING_USA_ORDER_STATUS.rejected]: 'error',
    [TRADING_ORDER_STATUS_CUSTOM.cancelRejectedAndFilled]:
      'cancel-rejected-filled',
  };

  public tooltipMessages = {
    [TRADING_ORDER_STATUS_CUSTOM.cancelRejectedAndFilled]: {
      [TRADING_ORDER_WAYS.buy]:
        'Tu solicitud de cancelación no fue aprobada, por lo que la compra se completó',
      [TRADING_ORDER_WAYS.sell]:
        'Tu solicitud de cancelación no fue aprobada, por lo que la venta se completó',
    },
    [TRADING_ORDER_STATUS.rejected]:
      'Lo sentimos, la operación no pudo ser realizada. Por favor, inténtalo de nuevo',
    [TRADING_USA_ORDER_STATUS.executedWithErrors]:
      'Lo sentimos, la operación no pudo ser realizada. Por favor, inténtalo de nuevo',
  };

  public ordersLenght: number;
  public totalRows = 1;

  public showSkeleton = true;
  public ordersEmptyState: any[] = [1, 2, 3];
  public isInternalUser = false;
  public isUsaContract = false;
  public showCancelButtons: boolean;
  public showModalCancelOrder = false;
  public cancellationMessage: string;

  public displayedColumns: DisplayedCapitalBlotterColumn[] = TRADING_MX_COLUMNS;

  private currentContract: string;
  private intervalTimeOut: number = +timeOuts_timeOut30Seg;

  private orderByPipe: OrderByPipe = new OrderByPipe();
  private source: any[] = [];
  private filter = '';
  private isReadAndWrite = true;
  private sourceData: any[] = [];
  private sort: FieldSort = new FieldSort();
  private listOfCanceledOrders: any[] = [];
  private elPatronData: any;
  private subscriptions = new Subscription();

  constructor(
    private store: Store<AppState>,
    private bootstrapService: BootstrapService,
    private tradeService: TradeService,
    private searchService: SearchService,
    private sharedSolaceStreamService: SharedSolaceStreamService,
    private utilitiesService: UtilitiesService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private patronService: PatronService,
    private notificationService: NotificationService,
    private analyticsTrackingService: AnalyticsTrackingService,
  ) {
    this.iconRegistry.addSvgIcon(
      'more',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'images/icons/ic_more_horiz.svg',
      ),
    );

    this.iconRegistry.addSvgIcon(
      'more_white',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'images/icons/opciones-negro.svg',
      ),
    );

    this.iconRegistry.addSvgIcon(
      'show_row',
      this.sanitizer.bypassSecurityTrustResourceUrl('images/icons/mas.svg'),
    );

    this.iconRegistry.addSvgIcon(
      'hide_row',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'images/icons/menos-negro.svg',
      ),
    );

    this.iconRegistry.addSvgIcon(
      'arrow',
      this.sanitizer.bypassSecurityTrustResourceUrl('images/icons/flecha.svg'),
    );
  }

  ngOnInit() {
    this.bootstrapPromise = this.bootstrapService.initSession().then(() => {
      this.sourceData = this.searchService.issues;

      this.subscriptions.add(
        this.store
          .select('currentContract')
          .pipe(
            map((values: any) => values.get('contractID')),
            filter((contractId: any) => contractId !== undefined),
            distinctUntilChanged(),
          )
          .subscribe((contractId: any) => {
            this.showSkeleton = true;
            this.currentContract = contractId;
            this.listOfCanceledOrders = [];
            this.orders = [];
            this.getOrders();
          }),
      );

      this.subscriptions.add(
        this.store
          .select('blotter')
          .pipe(
            map((values: any) => {
              return values.get('capitals') !== undefined
                ? values.get('capitals').toJS()
                : [];
            }),
            distinctUntilChanged(),
          )
          .subscribe((data: any[]) => {
            const selected: any[] = this.source.slice().filter((item: any) => {
              return item.showRow;
            });

            this.source = data;

            this.showCancelButtons = data.some((e) => e.isCancelable);

            for (const item of selected) {
              for (const newItem of this.source) {
                if (
                  newItem.sobId === item.sobId &&
                  newItem.hour === item.hour &&
                  newItem.issueId === item.issueId
                ) {
                  newItem.showRow = true;
                  break;
                }
              }
            }
            this.filterData('');
          }),
      );

      this.subscriptions.add(
        this.store
          .select('blotter')
          .pipe(
            map((values: any) => values.get('filter')),
            filter((data: any) => data !== undefined),
            distinctUntilChanged(),
          )
          .subscribe((filterShadowed: any) => {
            this.filter = filterShadowed;
            this.filterData(this.filter);
          }),
      );

      this.subscriptions.add(
        this.store
          .select('operation')
          .pipe(
            map((value: any) => value.toJS()),
            distinctUntilChanged(),
          )
          .subscribe((value: any) => {
            if (value.reset) {
              this.getOrders();

              this.store.dispatch({
                type: OPERATION_RESET,
                payload: { reset: false },
              });
            }
          }),
      );

      this.subscriptions.add(
        this.store.select(selectIsUsa).subscribe((isUsa) => {
          this.isUsaContract = isUsa;
          this.displayedColumns = isUsa
            ? TRADING_USA_COLUMNS
            : TRADING_MX_COLUMNS;
        }),
      );
      this.scanForUserRole();
      this.scanForElPatronData();
    });
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const { isRefreshing } = changes;
    if (isRefreshing && isRefreshing.currentValue !== undefined) {
      if (isRefreshing.currentValue) {
        this.showSkeleton = true;
      } else {
        this.showSkeleton = false;
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  cancelAndReplace(order: any): void {
    this.removeCancelButton(order);
    this.showCancelAndReplace(order);
  }

  cancel(order: any): void {
    const orderWay = order.way.toLowerCase();
    this.cancellationMessage = `Si ${
      this.isUsaContract ? `la bolsa invalida` : `las bolsas invalidan`
    }  tu orden se mostrará como cancelada, de lo
    contrario, tu ${orderWay} será completada`;
    this.handleToggleModal();
    this.removeCancelButton(order);
    this.showCancel(order);
  }

  showRow(order: any): void {
    order.showRow = true;
  }

  hideRow(order: any): void {
    order.showRow = false;
  }

  setSortingProp(property: string): void {
    if (!property || property === '') {
      return;
    }

    if (this.sorting.prop === property) {
      this.sorting.reverse = !this.sorting.reverse;
    } else {
      this.sorting.prop = property;
      this.sorting.reverse = true;
    }

    this.sortData();
  }

  generateExcel(): void {
    let generatedFile;
    const date = new Date().getTime();
    const length = size(this.orders);
    const exportObject: Array<Record<string, number | string>> = [];

    const fileHeaders = this.displayedColumns.reduce(
      (acc, column) => ({
        ...acc,
        [column.key]: column.title,
      }),
      {},
    );

    exportObject.push(fileHeaders);

    this.orders.forEach((order) =>
      exportObject.push(
        this.displayedColumns.reduce(
          (acc, column) => ({
            ...acc,
            [column.key]:
              !!column.csvFormatter && order.hasOwnProperty(column.key)
                ? column.csvFormatter(order[column.key])
                : order[column.key],
          }),
          {},
        ),
      ),
    );

    generatedFile = new AngularCsv(
      exportObject,
      `GBM_Homebroker_Ordenes_Capitales_${date}`,
    );
  }

  reorderST(property: string): void {
    this.orders = this.sort.SortField(property, this.orders);
  }

  public handleToggleModal(): void {
    this.showModalCancelOrder = !this.showModalCancelOrder;
  }

  public showTooltip(event: MouseEvent, isLargeTooltip?: boolean): void {
    const tooltipElement = (event.target as Element).lastElementChild;

    if (tooltipElement) {
      const { top, left } = (event.target as Element).getBoundingClientRect();
      this.constTop = top - 35;
      this.constLeft = left - 5;

      if (isLargeTooltip) {
        this.constTop = top - 85;
        this.constLeft = left - 10;
      }

      tooltipElement.classList.add('show');
    }
  }

  public hideTooltip(event: MouseEvent): void {
    const tooltipElement = (event.target as Element).lastElementChild;

    if (tooltipElement) {
      tooltipElement.classList.remove('show');
    }
  }

  private cancelCapitalMarketOrder(order: any): void {
    let orderId: string;

    if (order.vigencia) {
      orderId = order.vigenciaId;
    } else {
      orderId = order.predespachador ? order.preorderId : order.sobId;
    }

    const cancelRequest = this.isUsaContract
      ? this.tradeService.cancelUsaOrder(orderId)
      : this.tradeService.cancelCapitalMarketOrder(
          orderId,
          order.predespachador,
          order.vigencia,
        );

    this.subscriptions.add(
      cancelRequest.subscribe(
        () => {
          this.notificationService.showSuccess({
            title: 'Orden Cancelada',
            message: 'Se envió tu solicitud de cancelación',
            eventId: undefined,
            isBusinessError: false,
          });

          this.analyticsTrackingService.logEvent(
            TRACKING_EVENTS.send_order_cancelation.event,
            {
              ...TRACKING_EVENTS.send_order_cancelation.success,
              Origin: this.analyticsTrackingService.processOrigin(
                window.location.pathname,
              ),
            },
          );

          this.getOrders();
        },
        (error) => {
          this.analyticsTrackingService.logEvent(
            TRACKING_EVENTS.send_order_cancelation.event,
            {
              ...TRACKING_EVENTS.send_order_cancelation.error,
              Origin: this.analyticsTrackingService.processOrigin(
                window.location.pathname,
              ),
              Callback: error.message || error.ErrorMessage,
            },
          );
        },
      ),
    );
  }

  private filterData(filterText: string): void {
    if (filterText.length > 0) {
      this.orders = this.source.filter((item: any) => {
        const searchStr: string = item.issueId.toLowerCase();
        return searchStr.indexOf(filterText.toLowerCase()) !== -1;
      });
      return;
    } else {
      this.orders = this.source.filter((item: any) => {
        // In case of cancel rejected because order will be filled
        // we simulate a custom completed case with instructions about completed state
        if (
          item.status === TRADING_ORDER_STATUS.cancelRejected &&
          item.assignedQuantity > 0
        ) {
          item.status = TRADING_ORDER_STATUS_CUSTOM.cancelRejectedAndFilled;
          item.esStatus =
            this.statusOrders[
              TRADING_ORDER_STATUS_CUSTOM.cancelRejectedAndFilled
            ];
          item.icon =
            this.iconStatus[
              TRADING_ORDER_STATUS_CUSTOM.cancelRejectedAndFilled
            ];
        } else {
          item.esStatus = this.statusOrders[item.status];
          item.icon = this.iconStatus[item.status];
        }
      });
    }
    this.orders = this.source;

    this.ordersLenght = size(this.orders);
    this.totalRows = this.ordersLenght;
    this.sortData();
  }

  private sortData(): void {
    this.orders = this.orderByPipe.transform(
      this.orders,
      this.getConvertSortingProp(),
    );
  }

  private showCancel(order: any): void {
    const data = this.getData(order);
    data.isReadAndWrite = this.isReadAndWrite;
    if (data.isReadAndWrite) {
      this.cancelCapitalMarketOrder(order);
    } else {
      this._getChallenge(order, data, 1);
    }
  }

  private cancelAndReplaceModal(order: any, data: any) {
    const dialogRef: any = this.dialog.open(
      CancelAndReplaceConfirmationComponent,
      {
        disableClose: false,
        data,
      },
    );

    dialogRef
      .afterClosed()
      .toPromise()
      .then((result: boolean) => {
        if (result) {
          this.cancelCapitalMarketOrder(order);
        }
      });
  }

  private showCancelAndReplace(order: any): void {
    const isReplace = true;

    const data = this.getData(order);
    data.isReadAndWrite = this.isReadAndWrite;
    data.isReplace = isReplace;

    if (data.isReadAndWrite) {
      this.cancelCapitalMarketOrder(order);
      this.fillTradeCapitalComponent(order);
    } else {
      this._getChallenge(order, data, 0);
    }
  }

  private fillTradeCapitalComponent(order: any): void {
    const data = this.getData(order);
    const replaceTitles =
      data.order.originalQuantity -
      data.order.assignedQuantity -
      data.order.cancelQuantity;
    this.store.dispatch({
      type: BLOTTER_CANCELREPLACE,
      payload: {
        isCancelReplace: true,
        orderPrice: data.order.price,
        orderTypeId: data.order.orderTradeTypeId,
        orderReplaceTitles: replaceTitles,
      },
    });
    this.preFillOperation(order.issueId);
  }

  private getData(order: any): any {
    const issue: any = this.searchService.issues.filter((item: any) => {
      return item.issueID === order.issueId;
    })[0];

    const marketName: string =
      issue.instrumentType === MarketType.BMV ? 'marketBMV' : 'marketSIC';

    const solaceSymbol: any = this.sharedSolaceStreamService.getMarketElement(
      marketName,
      issue.issueID,
    );

    return {
      order,
      issue,
      solaceSymbol,
    };
  }

  private getOrders(isTimer: boolean = false): void {
    this.subscriptions.add(
      timer(0, this.intervalTimeOut)
        .pipe(
          mergeMap((period) =>
            this.tradeService
              .getCapitalMarketOrders(this.currentContract, isTimer || !!period)
              .pipe(catchError(() => EMPTY)),
          ),
        )
        .subscribe(() => (this.showSkeleton = false)),
    );
  }

  private getConvertSortingProp(): string {
    return this.sorting.reverse ? `-${this.sorting.prop}` : this.sorting.prop;
  }

  private processData(symbol: any): any {
    const sameSymbol = symbol.toLowerCase();

    const returnedSymbol = this.sourceData.filter((item: any) => {
      const searchStr: string = item.issueID.toLowerCase();
      if (searchStr === sameSymbol.replace(/&/g, 'ñ')) {
        return true;
      }
    });

    return returnedSymbol[0];
  }

  private preFillOperation(issueID: string) {
    const returnedSymbol: any = this.processData(issueID);

    this.store.dispatch({
      type: OPERATION_HARD_RESET,
      payload: { hardReset: true },
    });

    this.store.dispatch({
      type: CURRENT_SYMBOL,
      payload: returnedSymbol,
    });
    this.store.dispatch(new SelectTab(SelectedPuppetTab.TRADE));
  }

  private _getChallenge(order: any, data: any, type: number = 0) {
    this.subscriptions.add(
      this.patronService
        .getChallenge()
        .pipe(
          catchError((error: any) => {
            this.sendOperativeMessage('Error', error.message);

            return of(error);
          }),
        )
        .subscribe(() => this.cancelAndReplaceModal(order, data)),
    );
  }

  private scanForElPatronData() {
    this.subscriptions.add(
      this.store
        .select('elPatronData')
        .pipe(
          map((value: any) => value.toJS()),
          filter((value: any) => value.URL_SETTINGS !== undefined),
          take(1),
        )
        .subscribe((value: any) => {
          this.elPatronData = value;
        }),
    );
  }

  private sendOperativeMessage(titleText: string, messageText: string) {
    let notificationMessage: any = {};

    notificationMessage = {
      message: messageText || 'Necesitas ingresar el token',
      title: titleText || 'Token Necesario',
    };
    this.notificationService.showWarning(notificationMessage);
  }

  private removeCancelButton(order: any) {
    this.orders.forEach((single: any) => {
      if (single.sobId === order.sobId) {
        single.isCancelable = false;
        single.esStatus = 'Procesando';
      }
    });
  }

  private scanForUserRole() {
    this.subscriptions.add(
      this.store.select('userRole').subscribe((value: any) => {
        this.isInternalUser =
          value === USER_ROLES.RI || value === USER_ROLES.SUBDIRECTOR;
      }),
    );
  }
}

export interface BlotterOrderItem {
  hour: string | Date;
  sobId: string;
  issueId: string;
  capitalOrderType: string;
  way: string;
  originalQuantity: number;
  assignedQuantity: number;
  price: number;
  averagePrice: number;
  durationText: string;
  icon: string;
  esStatus: string;
  isCancelable: boolean;
  approximatedTitles?: number;
  amount?: number;
  status?: string;
}
